module.exports = __webpack_public_path__ + "static/media/hoppin2.8cbbd178.webp";